const DEFAULT_MAX_EVENT_BUFFER_SIZE = 0;
/**
 * Represents and event-bus style object associated to a particular event type with a payload that has shape T
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class SatelliteEventBus {
    constructor(config) {
        this.subscribedHandlers = [];
        this.eventBuffer = [];
        this.config = config || {
            maxEventBufferSize: DEFAULT_MAX_EVENT_BUFFER_SIZE,
        };
        this.config.maxEventBufferSize =
            (config === null || config === void 0 ? void 0 : config.maxEventBufferSize) || DEFAULT_MAX_EVENT_BUFFER_SIZE;
        this.dispatch = this.dispatch.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.bufferEvent = this.bufferEvent.bind(this);
        this.getSerializableConfig = this.getSerializableConfig.bind(this);
    }
    dispatch(payload) {
        this.bufferEvent(payload);
        this.subscribedHandlers.forEach((handler) => {
            handler(payload);
        });
    }
    subscribe(handler) {
        if (this.subscribedHandlers.includes(handler)) {
            return;
        }
        this.subscribedHandlers.push(handler);
        this.eventBuffer.forEach((payload) => {
            handler(payload);
        });
    }
    unsubscribe(handler) {
        this.subscribedHandlers = this.subscribedHandlers.filter((item) => item !== handler);
    }
    unsubscribeAll() {
        this.subscribedHandlers = [];
    }
    bufferEvent(payload) {
        this.eventBuffer.push(payload);
        if (this.eventBuffer.length > this.config.maxEventBufferSize) {
            this.eventBuffer.shift();
        }
    }
    /**
     * @internal
     * @returns Serialiable config values that can be sent via message passing
     */
    getSerializableConfig() {
        return this.config;
    }
}
//# sourceMappingURL=SatelliteEventBus.js.map